import { mainApi as api } from './emptyApi';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    authControllerSignin: build.mutation<
      AuthControllerSigninApiResponse,
      AuthControllerSigninApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/signin`,
        method: 'POST',
        body: queryArg.signInBodyDto,
      }),
    }),
    authControllerEmailSignUp: build.mutation<
      AuthControllerEmailSignUpApiResponse,
      AuthControllerEmailSignUpApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/email-signup`,
        method: 'POST',
        body: queryArg.emailSignUpBodyDto,
      }),
    }),
    authControllerEmailSignIn: build.mutation<
      AuthControllerEmailSignInApiResponse,
      AuthControllerEmailSignInApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/email-signin`,
        method: 'POST',
        body: queryArg.emailSignInBodyDto,
      }),
    }),
    authControllerResetPassword: build.mutation<
      AuthControllerResetPasswordApiResponse,
      AuthControllerResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/email-reset-password`,
        method: 'POST',
        body: queryArg.emailResetPasswordBodyDto,
      }),
    }),
    authControllerTelegramWidget: build.mutation<
      AuthControllerTelegramWidgetApiResponse,
      AuthControllerTelegramWidgetApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/telegram-widget`,
        method: 'POST',
        body: queryArg.telegramWidgetDataBodyDto,
      }),
    }),
    authControllerLinkTelegram: build.mutation<
      AuthControllerLinkTelegramApiResponse,
      AuthControllerLinkTelegramApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/link-telegram`,
        method: 'POST',
        body: queryArg.telegramWidgetDataBodyDto,
      }),
    }),
    authControllerLinkSite: build.mutation<
      AuthControllerLinkSiteApiResponse,
      AuthControllerLinkSiteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/link-site`,
        method: 'POST',
        body: queryArg.emailSignInBodyDto,
      }),
    }),
    authControllerWhoami: build.query<
      AuthControllerWhoamiApiResponse,
      AuthControllerWhoamiApiArg
    >({
      query: () => ({ url: `/api/auth/whoami` }),
    }),
    gameControllerStartSession: build.mutation<
      GameControllerStartSessionApiResponse,
      GameControllerStartSessionApiArg
    >({
      query: () => ({ url: `/api/game/start-session`, method: 'POST' }),
    }),
    photoControllerGetUserPhoto: build.query<
      PhotoControllerGetUserPhotoApiResponse,
      PhotoControllerGetUserPhotoApiArg
    >({
      query: () => ({ url: `/api/photo` }),
    }),
    photoControllerGetReferralUserPhoto: build.query<
      PhotoControllerGetReferralUserPhotoApiResponse,
      PhotoControllerGetReferralUserPhotoApiArg
    >({
      query: (queryArg) => ({
        url: `/api/photo/referral-user/${queryArg.userDisplayNumber}`,
      }),
    }),
    depositControllerGetHistory: build.query<
      DepositControllerGetHistoryApiResponse,
      DepositControllerGetHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/deposit/history`,
        params: { take: queryArg.take, skip: queryArg.skip },
      }),
    }),
    depositControllerGetDepositMinimalAmount: build.query<
      DepositControllerGetDepositMinimalAmountApiResponse,
      DepositControllerGetDepositMinimalAmountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/deposit/minimal-amount`,
        params: { payCurrency: queryArg.payCurrency },
      }),
    }),
    depositControllerGetDepositEstimatedFee: build.query<
      DepositControllerGetDepositEstimatedFeeApiResponse,
      DepositControllerGetDepositEstimatedFeeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/deposit/estimated-fee`,
        params: { payCurrency: queryArg.payCurrency, amount: queryArg.amount },
      }),
    }),
    depositControllerCreateDeposit: build.mutation<
      DepositControllerCreateDepositApiResponse,
      DepositControllerCreateDepositApiArg
    >({
      query: (queryArg) => ({
        url: `/api/deposit`,
        method: 'POST',
        body: queryArg.createDepositBodyDto,
      }),
    }),
    payoutControllerGetPayoutHistory: build.query<
      PayoutControllerGetPayoutHistoryApiResponse,
      PayoutControllerGetPayoutHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/payout/history`,
        params: { take: queryArg.take, skip: queryArg.skip },
      }),
    }),
    payoutControllerGetDepositEstimatedFee: build.query<
      PayoutControllerGetDepositEstimatedFeeApiResponse,
      PayoutControllerGetDepositEstimatedFeeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/payout/estimated-fee`,
        params: { currency: queryArg.currency, amount: queryArg.amount },
      }),
    }),
    payoutControllerGetPayoutMinimalWithdraw: build.query<
      PayoutControllerGetPayoutMinimalWithdrawApiResponse,
      PayoutControllerGetPayoutMinimalWithdrawApiArg
    >({
      query: (queryArg) => ({
        url: `/api/payout/minimal-payout`,
        params: { currency: queryArg.currency, amount: queryArg.amount },
      }),
    }),
    payoutControllerCreatePayout: build.mutation<
      PayoutControllerCreatePayoutApiResponse,
      PayoutControllerCreatePayoutApiArg
    >({
      query: (queryArg) => ({
        url: `/api/payout`,
        method: 'POST',
        body: queryArg.createPayoutBodyDto,
      }),
    }),
    referralControllerGetReferralUsers: build.query<
      ReferralControllerGetReferralUsersApiResponse,
      ReferralControllerGetReferralUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/referral/users`,
        params: { take: queryArg.take, skip: queryArg.skip },
      }),
    }),
    referralControllerGetReferralStats: build.query<
      ReferralControllerGetReferralStatsApiResponse,
      ReferralControllerGetReferralStatsApiArg
    >({
      query: () => ({ url: `/api/referral/referral-stats` }),
    }),
    referralControllerSetReferralCode: build.mutation<
      ReferralControllerSetReferralCodeApiResponse,
      ReferralControllerSetReferralCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/referral/set-referral-code`,
        method: 'POST',
        body: queryArg.setReferralCodeBodyDto,
      }),
    }),
    referralControllerCanChangeReferralCode: build.query<
      ReferralControllerCanChangeReferralCodeApiResponse,
      ReferralControllerCanChangeReferralCodeApiArg
    >({
      query: () => ({ url: `/api/referral/can-change-referral-code` }),
    }),
    healthControllerPing: build.query<
      HealthControllerPingApiResponse,
      HealthControllerPingApiArg
    >({
      query: () => ({ url: `/api/health` }),
    }),
    metricsControllerGetMetrics: build.query<
      MetricsControllerGetMetricsApiResponse,
      MetricsControllerGetMetricsApiArg
    >({
      query: () => ({ url: `/api/metrics` }),
    }),
    incomeControllerTakeReferralIncome: build.mutation<
      IncomeControllerTakeReferralIncomeApiResponse,
      IncomeControllerTakeReferralIncomeApiArg
    >({
      query: () => ({ url: `/api/income/take-referral-income`, method: 'POST' }),
    }),
    incomeControllerTakeJackpotIncome: build.mutation<
      IncomeControllerTakeJackpotIncomeApiResponse,
      IncomeControllerTakeJackpotIncomeApiArg
    >({
      query: () => ({ url: `/api/income/take-jackpot-income`, method: 'POST' }),
    }),
    incomeControllerTakePartnerIncome: build.mutation<
      IncomeControllerTakePartnerIncomeApiResponse,
      IncomeControllerTakePartnerIncomeApiArg
    >({
      query: () => ({ url: `/api/income/take-partner-income`, method: 'POST' }),
    }),
    regionAvailabilityControllerPing: build.query<
      RegionAvailabilityControllerPingApiResponse,
      RegionAvailabilityControllerPingApiArg
    >({
      query: () => ({ url: `/api/region-availability` }),
    }),
    verificationControllerGenerateAccessToken: build.mutation<
      VerificationControllerGenerateAccessTokenApiResponse,
      VerificationControllerGenerateAccessTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/api/verification/access-token`,
        method: 'POST',
        body: queryArg.generateAccessTokenInputDto,
      }),
    }),
    verificationControllerProcessWebhook: build.mutation<
      VerificationControllerProcessWebhookApiResponse,
      VerificationControllerProcessWebhookApiArg
    >({
      query: () => ({ url: `/api/verification/webhook`, method: 'POST' }),
    }),
    partnerProgramControllerGetPartnerInfo: build.query<
      PartnerProgramControllerGetPartnerInfoApiResponse,
      PartnerProgramControllerGetPartnerInfoApiArg
    >({
      query: () => ({ url: `/api/partner/info` }),
    }),
    adminControllerLogin: build.mutation<
      AdminControllerLoginApiResponse,
      AdminControllerLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/login`,
        method: 'POST',
        body: queryArg.loginInputDto,
      }),
    }),
    adminControllerAddPartner: build.mutation<
      AdminControllerAddPartnerApiResponse,
      AdminControllerAddPartnerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/partner`,
        method: 'POST',
        body: queryArg.addPartnerInputDto,
      }),
    }),
    adminControllerChangePartnerJackpotParticipation: build.mutation<
      AdminControllerChangePartnerJackpotParticipationApiResponse,
      AdminControllerChangePartnerJackpotParticipationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/partner`,
        method: 'PATCH',
        body: queryArg.changePartnerInformationInputDto,
      }),
    }),
    adminControllerGetPartnerByUuid: build.query<
      AdminControllerGetPartnerByUuidApiResponse,
      AdminControllerGetPartnerByUuidApiArg
    >({
      query: (queryArg) => ({ url: `/api/admin/partner/${queryArg.uuid}` }),
    }),
    adminControllerRemovePartner: build.mutation<
      AdminControllerRemovePartnerApiResponse,
      AdminControllerRemovePartnerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/partner/${queryArg.uuid}`,
        method: 'DELETE',
      }),
    }),
    adminControllerGetAllPartners: build.query<
      AdminControllerGetAllPartnersApiResponse,
      AdminControllerGetAllPartnersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/partner/all`,
        params: { take: queryArg.take, skip: queryArg.skip },
      }),
    }),
    reserveControllerGetReserve: build.query<
      ReserveControllerGetReserveApiResponse,
      ReserveControllerGetReserveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/reserve`,
        params: { reserveType: queryArg.reserveType },
      }),
    }),
    virtualBalanceControllerIncreaseUserBalance: build.mutation<
      VirtualBalanceControllerIncreaseUserBalanceApiResponse,
      VirtualBalanceControllerIncreaseUserBalanceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/virtual-balance/increase/${queryArg.userId}/${queryArg.amount}`,
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as restApi };
export type AuthControllerSigninApiResponse = /** status 200  */ {
  token?: string;
};
export type AuthControllerSigninApiArg = {
  signInBodyDto: SignInBodyDto;
};
export type AuthControllerEmailSignUpApiResponse = /** status 200  */ {
  token?: string;
};
export type AuthControllerEmailSignUpApiArg = {
  emailSignUpBodyDto: EmailSignUpBodyDto;
};
export type AuthControllerEmailSignInApiResponse = /** status 200  */ {
  token?: string;
};
export type AuthControllerEmailSignInApiArg = {
  emailSignInBodyDto: EmailSignInBodyDto;
};
export type AuthControllerResetPasswordApiResponse = unknown;
export type AuthControllerResetPasswordApiArg = {
  emailResetPasswordBodyDto: EmailResetPasswordBodyDto;
};
export type AuthControllerTelegramWidgetApiResponse = /** status 200  */ {
  token?: string;
};
export type AuthControllerTelegramWidgetApiArg = {
  telegramWidgetDataBodyDto: TelegramWidgetDataBodyDto;
};
export type AuthControllerLinkTelegramApiResponse = unknown;
export type AuthControllerLinkTelegramApiArg = {
  telegramWidgetDataBodyDto: TelegramWidgetDataBodyDto;
};
export type AuthControllerLinkSiteApiResponse = unknown;
export type AuthControllerLinkSiteApiArg = {
  emailSignInBodyDto: EmailSignInBodyDto;
};
export type AuthControllerWhoamiApiResponse = /** status 200  */ UserDto;
export type AuthControllerWhoamiApiArg = void;
export type GameControllerStartSessionApiResponse = /** status 200  */ {
  gameServerUrl?: string;
  token?: string;
};
export type GameControllerStartSessionApiArg = void;
export type PhotoControllerGetUserPhotoApiResponse = unknown;
export type PhotoControllerGetUserPhotoApiArg = void;
export type PhotoControllerGetReferralUserPhotoApiResponse = unknown;
export type PhotoControllerGetReferralUserPhotoApiArg = {
  userDisplayNumber: number;
};
export type DepositControllerGetHistoryApiResponse = /** status 200  */ DepositHistoryDto;
export type DepositControllerGetHistoryApiArg = {
  take?: number;
  skip?: number;
};
export type DepositControllerGetDepositMinimalAmountApiResponse = /** status 200  */ {
  minimalAmount?: number;
};
export type DepositControllerGetDepositMinimalAmountApiArg = {
  payCurrency: string;
};
export type DepositControllerGetDepositEstimatedFeeApiResponse = /** status 200  */ {
  estimatedFee?: number;
};
export type DepositControllerGetDepositEstimatedFeeApiArg = {
  payCurrency: string;
  amount: string;
};
export type DepositControllerCreateDepositApiResponse = /** status 201  */ DepositDto;
export type DepositControllerCreateDepositApiArg = {
  createDepositBodyDto: CreateDepositBodyDto;
};
export type PayoutControllerGetPayoutHistoryApiResponse =
  /** status 200  */ PayoutHistoryDto;
export type PayoutControllerGetPayoutHistoryApiArg = {
  take?: number;
  skip?: number;
};
export type PayoutControllerGetDepositEstimatedFeeApiResponse = /** status 200  */ {
  estimatedFee?: number;
};
export type PayoutControllerGetDepositEstimatedFeeApiArg = {
  currency: string;
  amount: string;
};
export type PayoutControllerGetPayoutMinimalWithdrawApiResponse = /** status 200  */ {
  minimalPayout?: number;
};
export type PayoutControllerGetPayoutMinimalWithdrawApiArg = {
  currency: string;
  amount: string;
};
export type PayoutControllerCreatePayoutApiResponse = /** status 201  */ PayoutDto;
export type PayoutControllerCreatePayoutApiArg = {
  createPayoutBodyDto: CreatePayoutBodyDto;
};
export type ReferralControllerGetReferralUsersApiResponse =
  /** status 200  */ ReferralUserListDto;
export type ReferralControllerGetReferralUsersApiArg = {
  take?: number;
  skip?: number;
};
export type ReferralControllerGetReferralStatsApiResponse =
  /** status 200  */ ReferralStatsDto;
export type ReferralControllerGetReferralStatsApiArg = void;
export type ReferralControllerSetReferralCodeApiResponse = unknown;
export type ReferralControllerSetReferralCodeApiArg = {
  setReferralCodeBodyDto: SetReferralCodeBodyDto;
};
export type ReferralControllerCanChangeReferralCodeApiResponse =
  /** status 200  */ boolean;
export type ReferralControllerCanChangeReferralCodeApiArg = void;
export type HealthControllerPingApiResponse = /** status 200  */ string;
export type HealthControllerPingApiArg = void;
export type MetricsControllerGetMetricsApiResponse = unknown;
export type MetricsControllerGetMetricsApiArg = void;
export type IncomeControllerTakeReferralIncomeApiResponse = /** status 200  */ boolean;
export type IncomeControllerTakeReferralIncomeApiArg = void;
export type IncomeControllerTakeJackpotIncomeApiResponse = /** status 200  */ boolean;
export type IncomeControllerTakeJackpotIncomeApiArg = void;
export type IncomeControllerTakePartnerIncomeApiResponse = /** status 200  */ boolean;
export type IncomeControllerTakePartnerIncomeApiArg = void;
export type RegionAvailabilityControllerPingApiResponse = /** status 200  */ string;
export type RegionAvailabilityControllerPingApiArg = void;
export type VerificationControllerGenerateAccessTokenApiResponse =
  /** status 200  */ GenerateAccessTokenOutputDto;
export type VerificationControllerGenerateAccessTokenApiArg = {
  generateAccessTokenInputDto: GenerateAccessTokenInputDto;
};
export type VerificationControllerProcessWebhookApiResponse = unknown;
export type VerificationControllerProcessWebhookApiArg = void;
export type PartnerProgramControllerGetPartnerInfoApiResponse =
  /** status 200  */ PartnerInfoOutputDto;
export type PartnerProgramControllerGetPartnerInfoApiArg = void;
export type AdminControllerLoginApiResponse = /** status 200  */ LoginOutputDto;
export type AdminControllerLoginApiArg = {
  loginInputDto: LoginInputDto;
};
export type AdminControllerAddPartnerApiResponse = unknown;
export type AdminControllerAddPartnerApiArg = {
  addPartnerInputDto: AddPartnerInputDto;
};
export type AdminControllerChangePartnerJackpotParticipationApiResponse = unknown;
export type AdminControllerChangePartnerJackpotParticipationApiArg = {
  changePartnerInformationInputDto: ChangePartnerInformationInputDto;
};
export type AdminControllerGetPartnerByUuidApiResponse =
  /** status 200  */ PartnerRecordDto;
export type AdminControllerGetPartnerByUuidApiArg = {
  uuid: string;
};
export type AdminControllerRemovePartnerApiResponse = unknown;
export type AdminControllerRemovePartnerApiArg = {
  uuid: string;
};
export type AdminControllerGetAllPartnersApiResponse = /** status 200  */ PartnerListDto;
export type AdminControllerGetAllPartnersApiArg = {
  take?: number;
  skip?: number;
};
export type ReserveControllerGetReserveApiResponse = /** status 200  */ ReserveDto;
export type ReserveControllerGetReserveApiArg = {
  reserveType: 'General';
};
export type VirtualBalanceControllerIncreaseUserBalanceApiResponse =
  /** status 200  */ boolean;
export type VirtualBalanceControllerIncreaseUserBalanceApiArg = {
  userId: string;
  amount: string;
};
export type SignInBodyDto = {
  telegramInitData: string;
};
export type EmailSignUpBodyDto = {
  email: string;
  password: string;
  referralCode?: string;
};
export type EmailSignInBodyDto = {
  email: string;
  password: string;
};
export type EmailResetPasswordBodyDto = {
  email: string;
  password: string;
  newPassword: string;
};
export type TelegramWidgetDataBodyDto = {
  id: string;
  firstName: string;
  lastName: string;
  username: string;
  photoUrl: string;
  authDate: string;
  hash: string;
};
export type UserJackpotEarningsHistory = {
  date: string;
  amount: string;
};
export type UserPartnerEarningsHistory = {
  date: string;
  amount: string;
};
export type UserDto = {
  id: string;
  username?: string;
  displayNumber: number;
  balance: string;
  receivedReferralIncome: string;
  unreceivedReferralIncome: string;
  totalJackpotWinnings: string;
  unreceivedJackpotWinnings: string;
  isPartner: boolean;
  verificationLevel?: 'kyc_simple' | 'kyc_standard' | 'kyc_enhanced';
  verificationLStatus?:
    | 'requested'
    | 'verified'
    | 'pending'
    | 'resubmission_required'
    | 'failed';
  sumSubApplicantId?: string;
  referralCode?: string;
  referralCodeLastUpdated?: string;
  jackpotEarningshistory: UserJackpotEarningsHistory[];
  partnerEarningshistory: UserPartnerEarningsHistory[];
};
export type DepositDto = {
  id: string;
  amount: number;
  payAddress: string;
  payCurrency: string;
  payAmount: string;
  actualFee: string;
  status:
    | 'waiting'
    | 'expired'
    | 'failed'
    | 'finished'
    | 'partially_paid'
    | 'confirming'
    | 'on_hold';
  createdAt: string;
};
export type DepositHistoryDto = {
  count: number;
  deposits: DepositDto[];
};
export type CreateDepositBodyDto = {
  amount: number;
  payCurrency: string;
};
export type PayoutDto = {
  id: string;
  createdAt: string;
  address: string;
  status: 'waiting' | 'failed' | 'finished' | 'rejected' | 'on_hold';
  currency: string;
  amount: number;
  actualFee: string;
  fiatAmount: number;
};
export type PayoutHistoryDto = {
  count: number;
  payouts: PayoutDto[];
};
export type CreatePayoutBodyDto = {
  address: string;
  currency: string;
  fiatAmount: number;
};
export type ReferralUserDto = {
  displayNumber: number;
  username?: string;
  receivedIncome: string;
};
export type ReferralUserListDto = {
  count: number;
  referralUsers: ReferralUserDto[];
};
export type ReferralStatsByLevelDto = {
  referralsCount: string;
  earnings: string;
};
export type ReferralStatsDto = {
  count: number;
  statsByLevel: ReferralStatsByLevelDto[];
};
export type SetReferralCodeBodyDto = {
  /** Referral code (4-30 characters, letters and numbers only, cannot be only digits) */
  referralCode: string;
};
export type GenerateAccessTokenOutputDto = {
  token: string;
  userId: string;
};
export type GenerateAccessTokenInputDto = {
  levelName: 'kyc_simple' | 'kyc_standard' | 'kyc_enhanced';
};
export type PartnerEarningDto = {
  earnings: string;
  date: string;
};
export type PartnerInfoOutputDto = {
  infectedUsersCount: number;
  unclaimedPartnerEarnings: string;
  totalClaimedPartnerEarnings: string;
  earningsByLast30Days: PartnerEarningDto[];
  isPartner: boolean;
  partnerLevel: string;
};
export type LoginOutputDto = {
  token: string;
};
export type LoginInputDto = {
  username: string;
  password: string;
};
export type AddPartnerInputDto = {
  userDisplayNumber: string;
  minimalInterestRate: string;
  canParticipatePartnerJackpot: boolean;
};
export type ChangePartnerInformationInputDto = {
  userDisplayNumber: string;
  canParticipatePartnerJackpot: boolean;
  minimalInterestRate: string;
  currentInterestRate: string;
};
export type PartnerRecordDto = {
  username: string;
  userDisplayNumber: string;
  userId: string;
  minimalInterestRate: string;
  currentInterestRate: string;
  accessToPartnerJackpot: boolean;
  rewardForLast30Days: string;
  totalReward: string;
};
export type PartnerListDto = {
  totalCount: number;
  partners: PartnerRecordDto[];
};
export type ReserveDto = {
  id: 'General';
  revenue: string;
  referralReserve: string;
  jackpotReserve: string;
  topPlayersReserve: string;
  partnerReserve: string;
  unorderedDigitsMatchesReserve: string;
  orderedDigitsMatchesReserve: string;
  f1JackpotReserve: string;
  metallicTicketsReserve: string;
};
export const {
  useAuthControllerSigninMutation,
  useAuthControllerEmailSignUpMutation,
  useAuthControllerEmailSignInMutation,
  useAuthControllerResetPasswordMutation,
  useAuthControllerTelegramWidgetMutation,
  useAuthControllerLinkTelegramMutation,
  useAuthControllerLinkSiteMutation,
  useAuthControllerWhoamiQuery,
  useGameControllerStartSessionMutation,
  usePhotoControllerGetUserPhotoQuery,
  usePhotoControllerGetReferralUserPhotoQuery,
  useDepositControllerGetHistoryQuery,
  useDepositControllerGetDepositMinimalAmountQuery,
  useDepositControllerGetDepositEstimatedFeeQuery,
  useDepositControllerCreateDepositMutation,
  usePayoutControllerGetPayoutHistoryQuery,
  usePayoutControllerGetDepositEstimatedFeeQuery,
  usePayoutControllerGetPayoutMinimalWithdrawQuery,
  usePayoutControllerCreatePayoutMutation,
  useReferralControllerGetReferralUsersQuery,
  useReferralControllerGetReferralStatsQuery,
  useReferralControllerSetReferralCodeMutation,
  useReferralControllerCanChangeReferralCodeQuery,
  useHealthControllerPingQuery,
  useMetricsControllerGetMetricsQuery,
  useIncomeControllerTakeReferralIncomeMutation,
  useIncomeControllerTakeJackpotIncomeMutation,
  useIncomeControllerTakePartnerIncomeMutation,
  useRegionAvailabilityControllerPingQuery,
  useVerificationControllerGenerateAccessTokenMutation,
  useVerificationControllerProcessWebhookMutation,
  usePartnerProgramControllerGetPartnerInfoQuery,
  useAdminControllerLoginMutation,
  useAdminControllerAddPartnerMutation,
  useAdminControllerChangePartnerJackpotParticipationMutation,
  useAdminControllerGetPartnerByUuidQuery,
  useAdminControllerRemovePartnerMutation,
  useAdminControllerGetAllPartnersQuery,
  useReserveControllerGetReserveQuery,
  useVirtualBalanceControllerIncreaseUserBalanceMutation,
} = injectedRtkApi;
